import { environmentHttpClient } from "client/Api/httpClient";
import { MaintenanceWindowAppModel } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { EmbedAppContentKind } from "../EditApp/saveApp";

export type EmbedAppPageModel = {
	appId: number;
	title: string;
	navigationUrl: string | null;
	conditionalAccess: OptionalModel<ConditionalAccessRestrictionModel>;
	maintenanceWindow: OptionalModel<MaintenanceWindowAppModel>;
};

export type ConditionalAccessRestrictionModel = {
	reason: string;
};

export function getModel(appId: number, signal?: AbortSignal): Promise<EmbedAppPageModel> {
	return environmentHttpClient.get<EmbedAppPageModel>(
		`/WebContent/${appId}/Data`,
		undefined,
		{ signal }
	);
}

export type EmbedAppContentModel = {
	kind: EmbedAppContentKind;
	html: string;
};

export function getContent(appId: number, signal?: AbortSignal): Promise<EmbedAppContentModel> {
	return environmentHttpClient.get<EmbedAppContentModel>(
		`/WebContent/${appId}/Content`,
		undefined,
		{ signal }
	);
}
